import {Component, computed, inject} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {ActivatedRoute, Router} from '@angular/router';
import {HostDetailsComponent} from '@domain/host/host-details/host-details.component';
import {HostDTO} from '@domain/host/host.dto';
import {ActivityDTO} from '@domain/activity/activity.dto';
import {LucideAngularModule, Share2Icon} from "lucide-angular";
import {ResponsiveButtonsComponent} from "@shared/container/responsive-buttons/responsive-buttons.component";
import {
  ActivitySearchService
} from '@public/activity/search-activity/components/activity-search-filters/activity-search.service';
import {NotificationService} from '@shared/notification/notification.service';
import {BrowserService} from '@core/service/browser.service';
import {HostUtil} from '@domain/host/host.util';
import {RouteGenerator} from '@core/route-generator';
import {UI_ROUTES} from '@core/ui.routes';

@Component({
  selector: 'app-public-view-host-details',
  imports: [
    HostDetailsComponent,
    LucideAngularModule,
    ResponsiveButtonsComponent
  ],
  templateUrl: './host-home.component.html'
})
export class HostHomeComponent {

  private readonly route = inject(ActivatedRoute);
  private readonly data = toSignal(this.route.data);
  public readonly host = computed(() => this.data()?.host as HostDTO);
  public readonly activities = computed(() => this.data()?.activities as ActivityDTO[]);

  public readonly icons = {
    share: Share2Icon
  };

  public readonly routes = {
    home: RouteGenerator.abs(UI_ROUTES.public.dashboard),
    search: RouteGenerator.abs(UI_ROUTES.public.activity.search)
  };

  private readonly router = inject(Router);
  private readonly searchService = inject(ActivitySearchService);
  private readonly notifyService = inject(NotificationService);
  private readonly browserService = inject(BrowserService);

  public share(): void {
    const slugUrl = this.getUrl();
    if (!slugUrl) {
      return;
    }
    if (this.browserService.copyToClipboard(slugUrl)) {
      this.notifyService.toast({
        message: `C'est copié: partage cette adresse pour montrer ton organisation.`
      });
    }
  }

  public close(): void {
    const search = this.searchService.getSearchResponse();
    if (!!search) {
      this.router.navigate(
        [this.routes.search],
        {
          queryParams: search.search
        }
      ).then(_ok =>  {});
    } else {
      this.router.navigate([this.routes.home]).then(_ok =>  {});
    }
  }

  private getUrl(): string | null {
    const slug = HostUtil.getSlug(this.host());
    if (!slug) {
      return null;
    }
    return RouteGenerator.uiUrl(UI_ROUTES.public.host.home, {slug: slug});
  }

}
